<template>
  <xm-page class="school-page">
    <xm-page-content>
      <div>
        <div class="point-title">请选择进入在线商城的校区</div>
        <div>
          <ul class="school-list">
            <li v-for="(item, index) in schoolList" @click="toMall(item)" :key="index">
              <div class="avatar">
                <img :src="item.banner || instImg" />
              </div>
              <div class="inst-desc">
                <div class="name">{{item.instName}}</div>
                <div class="student">
                  <span v-for="(studentItem,studentIndex) in item.student" :key="studentIndex">
                    {{studentItem.studentName}}
                    <span v-if="(studentIndex< item.student.length-1)">、</span>
                  </span>
                </div>
                <span class="control icon iconfont">&#xe68a;</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </xm-page-content>
  </xm-page>
</template>
<script>
import User from "@/core/user";
import UserService from "@/service/UserService";
import instImg from "@/images/accountbind.png";
import Service from "../../service/Service";
export default {
  data() {
    return {
      schoolList: [],
      bindStudentList: [],
      instImg
    };
  },
  created() {},
  mounted() {
    this.getMergeInstlist();
  },
  methods: {
    getMergeInstlist() {
      const appId = User.appId();
      const data = {
        appId,
        instAuthCode: "ONLINE_MALL",
        userId: User.uid()
      };
      Service.doAsyncRequest("customer/anon/groupToStudent/bindList", {
        params: JSON.stringify(data),
        contentType: "application/json; charset=UTF-8",
        heimdall: true
      }).then(res => {
        const schoolList = _.filter(res.result, item => {
          return item.openOnlineMall;
        });
        this.allOnlineMallStudent = schoolList;
        const list = [];
        const ids = [];
        this.schoolList = _.map(schoolList, item => {
          if (ids.indexOf(item.instId) == -1) {
            list.push(item);
            ids.push(item.instId);
          }
        });
        this.schoolList = list;
      });
    },
    toMall(data) {
      if (data.saasVersion === "V_40") {
        const list = _.filter(this.allOnlineMallStudent, item => {
          return item.instId == data.instId;
        });
        if (list.length > 1) {
          window.router.push({
            name: "online_select_student",
            query: {
              instId: data.instId
            }
          });
        } else {
          User.setUserInfo(data);
          window.router.push({
            name: "course_mall",
            query: {
              studentId: data.studentId,
              mallInstId: data.instId
            }
          });
        }
      } else {
        window.router.push({
          name: "online_product_list",
          query: {
            instId: data.instId,
            instName: data.instName
          }
        });
      }
    }
  },
  components: {}
};
</script>
<style lang="less">
@import url(../../core/mixins.less);
.school-page {
  .point-title {
    text-align: left;
    padding:8px 0.16rem;
    font-size: 0.26rem;
    color: #999999;
  }
  .school-list {
    li {
      background-color: #ffffff;
      display: flex;
      position: relative;
      padding: 0.32rem 0.32rem;
      width: 100%;
      align-items: center;
      border-bottom: 1px solid #eee;
      .avatar {
        margin-right: 0.3rem;
        width: 1rem;
        > img {
          display: block;
          height: 1rem;
          width: 1rem;
          border-radius: 50%;
        }
      }
      .inst-desc {
        flex: 1;
        .name {
          color: #333;
          font-size: 0.3rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0.18rem;
          width: 4.98rem;
        }
        .student {
          font-size: 0.26rem;
          color: #999999;
        }
        .control {
          padding: 0.3rem;
          font-size: 14px;
          color: #909090;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      &:last-child {
        border-bottom: 0px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/module/mall/School.vue